<template>
  <div class="dark-version">
    <label id="switch" class="switch">
      <input type="checkbox" @click="toggleDarkMode" id="slider" />
      <span class="slider round"></span>
    </label>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LightDarkSwtichBtn",

  data() {
    return {
      isDarkMode: true,
    };
  },
  methods: {
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      document.body.classList.toggle("theme-dark", this.isDarkMode);
      localStorage.setItem("theme-dark", this.isDarkMode.toString());
    },
  },
  mounted() {
  const storedDarkMode = localStorage.getItem("theme-dark");

  // ✅ Make dark mode default if nothing is stored
  if (storedDarkMode === null) {
    this.isDarkMode = true;
    document.body.classList.add("theme-dark");
    localStorage.setItem("theme-dark", "true");
  } else {
    this.isDarkMode = storedDarkMode === "true";
    document.body.classList.toggle("theme-dark", this.isDarkMode);
  }
}

});
</script>